export const MIN_BANNER_HEIGHT = 94;
export const NEW_MIN_BANNER_HEIGHT = 114;
export const BANNER_NAME = 'CookiesConsentBanner';
